import React, {useCallback} from 'react';

import {AllPolymerLayouts} from 'constants/MapsConstants';
import ProteinActions from 'molbio/aa-sequences/AaSequenceActions';
import ProteinStore from 'molbio/aa-sequences/AaSequenceStore';
import PolymerSearchResultRegion from 'molbio/maps/linear/PolymerSearchResultRegion';
import SequenceMapUtil from 'molbio/maps/SequenceMapUtil';
import {isRangeOverlap} from 'molbio/SeqUtil';
import {selectRange} from 'toolbar/aa-sequence/AaSequenceUIGlobalState';
import useStoreSelector from 'ui-library/hooks/useStoreSelector';

interface AminoAcidsSearchResultsProps {
  sliceStart: number;
  sliceEnd: number;
  proteinId: string;
  layout: AllPolymerLayouts['aminoAcids'];
  xFn: (index: number) => number;
}

export default function AminoAcidsSearchResults({
  sliceStart,
  sliceEnd,
  proteinId,
  layout,
  xFn,
}: AminoAcidsSearchResultsProps): JSX.Element {
  const searchResults = useStoreSelector(
    ProteinStore,
    useCallback((proteinStore) => proteinStore.getSearchResults(proteinId), [proteinId])
  );
  const filteredSearchResults = searchResults.filter((searchResult) =>
    isRangeOverlap(
      sliceStart,
      sliceEnd,
      searchResult.index,
      searchResult.index + searchResult.aminoAcids.length
    )
  );
  return (
    <>
      {filteredSearchResults.map(({index, aminoAcids, isSelected}) => (
        <PolymerSearchResultRegion
          key={`${index}-${aminoAcids}`}
          xFn={xFn}
          regionStartIndex={index}
          regionLength={aminoAcids.length}
          y={0}
          height={SequenceMapUtil.aminoAcidBoxHeight(layout) + layout.spacer}
          isSelected={Boolean(isSelected)}
          onClick={() => {
            selectRange(proteinId, index, index + aminoAcids.length);
            ProteinActions.selectSearchResult({index, aminoAcids, proteinId});
          }}
        />
      ))}
    </>
  );
}
